export class Path {
  constructor(
    public key?: string,
    public value?: string,
  ) { }
}
